import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateIndicadorsModificats } from "../../actions/configFormularioAction";
import { crearTotOkAction } from "../../actions/ui";

export const ComponenteFormularioIndicadores = ({ catIndex }) => {
  const dispatch = useDispatch();
  const { auth,configFormulario, ui } = useSelector((state) => state);
  const infoFormularioIndicadoresCategoria =
    configFormulario?.infoFormularioIndicadoresCategoria;
  const infoFormularioTextCategoria =
    configFormulario?.infoFormularioTextCategoria;
  const pesoFinalCategoria =
    infoFormularioIndicadoresCategoria?.nuevaVersion?.PesoFinalCategoria || [];
  const pesoFinalCategoriaProgramas =
    infoFormularioIndicadoresCategoria?.nuevaVersion
      ?.PesoFinalCategoria_Programas || [];

  const estadoIndicadores = ui?.indicadoresState || 1;
  let valoresIniciales,
    valoresActuales,
    sumaEsperada,
    datosNueva,
    datosActual,
    textosCategoria,
    tooltipPrefix;
  // Definir las claves dinámicas según el estado de indicadores

  if (catIndex === 10) {
    // Si es peso general, trabajar con los pesos generales
    datosNueva =
      estadoIndicadores === 1
        ? pesoFinalCategoria
        : pesoFinalCategoriaProgramas;
    datosActual =
      estadoIndicadores === 1
        ? infoFormularioIndicadoresCategoria?.actualVersion?.PesoFinalCategoria
        : infoFormularioIndicadoresCategoria?.actualVersion
            ?.PesoFinalCategoria_Programas;
    sumaEsperada = estadoIndicadores === 1 ? 900 : 100;
  } else {
    const textosKey = `Categoria${catIndex}`;
    const categoriaKey =
      estadoIndicadores === 1
        ? `Categoria${catIndex}`
        : `Categoria${catIndex}_Programas`;
    tooltipPrefix =
      estadoIndicadores === 1 ? `Cat${catIndex}_Preg` : `Cat${catIndex}_Prog`;

    datosNueva =
      infoFormularioIndicadoresCategoria?.nuevaVersion?.[categoriaKey] || [];
    datosActual =
      infoFormularioIndicadoresCategoria?.actualVersion?.[categoriaKey] || [];
    textosCategoria = infoFormularioTextCategoria?.[textosKey] || {};

    sumaEsperada =
      estadoIndicadores === 1
        ? 100
        : pesoFinalCategoriaProgramas[catIndex - 1] || 0;
  }
  const [valores, setValores] = useState(Array.isArray(datosNueva) ? datosNueva : []);

 useEffect(() => {
  setValores(Array.isArray(datosNueva) ? datosNueva : []);
}, [catIndex, estadoIndicadores, datosNueva]);

  if (
    !infoFormularioIndicadoresCategoria ||
    !infoFormularioIndicadoresCategoria.nuevaVersion
  ) {
    return (
      <p className="error">Error: No se encontró la información necesaria.</p>
    );
  }

  const actualizarValores = (index, nuevoValor) => {
    let nuevaLista = [...valores];
    nuevaLista[index] = nuevoValor;
    setValores(nuevaLista);
  };

  const guardarValores = () => {
    const sumaTotal = Math.round(valores.reduce((acc, val) => acc + val, 0));

    if (sumaTotal !== sumaEsperada) {
      alert(`La suma de los valores debe ser exactamente ${sumaEsperada}.`);
      return;
    }

    dispatch(updateIndicadorsModificats(auth.tokenJwt, valores,estadoIndicadores,catIndex,infoFormularioIndicadoresCategoria.nuevaVersion.version));
    if(estadoIndicadores==1){
          dispatch(crearTotOkAction(`Resultados de los indicadores de la categoria ${catIndex} modificados.`));
    }else{
          dispatch(crearTotOkAction(`Resultados de los indicadores del programa ${catIndex} modificados.`));
    }
    // Aquí se ejecutaría la acción de guardado
    // dispatch(guardar(valores));

  };

  // Filtrar los valores para que no se muestren aquellos que son 0 en estadoIndicadores = 2
  const valoresFiltradosActual =
    estadoIndicadores === 2
      ? datosActual.filter((valor) => valor !== 0)
      : datosActual;

  const valoresFiltradosNueva =
    estadoIndicadores === 2 ? valores.filter((valor) => valor !== 0) : valores;

  return (
    <div className="contenedor-formulario">
      <h3>La suma de ponderacions ha de sumar {sumaEsperada}</h3>

      <table className="tabla-valores">
        <thead>
          <tr className="bg-gray-200">
            <th className="border p-2">Información</th>
            <th className="border p-2">Valor Actual</th>
            <th className="border p-2">Nuevo Valor</th>
          </tr>
        </thead>
        <tbody>
          {valoresFiltradosNueva.map((valor, index) => {
            let textoReferencia;
            if (catIndex === 10) {
              textoReferencia = infoFormularioTextCategoria?.[`Categoria${index + 1}`][`Cat${index+1}_Titol`];

            } else {
              const keyTexto = `${tooltipPrefix}${index + 1}`;
               textoReferencia =textosCategoria?.[keyTexto] || "Sin información";
            }
            return (
              <tr key={index}>
                <td className="info-texto" style={{ textAlign: "left" }}>
                  {textoReferencia}
                </td>
                <td className="valor-referencia">
                  {valoresFiltradosActual[index] ?? "-"}
                </td>
                <td>
                  <input
                    type="number"
                    value={valor}
                    onChange={(e) =>
                      actualizarValores(index, Number(e.target.value))
                    }
                    min="0"
                    className="input-valor"
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <p className="suma-total">
        <strong>Suma dels nous valors:</strong>{" "}
        {Math.round(valores.reduce((acc, val) => acc + val, 0))}
      </p>

      <button className="btn-guardar" onClick={guardarValores}>
        Guardar nuevos valores
      </button>
    </div>
  );
};
